import { createElement } from 'react';
import { oneOfType, node, func, string, bool, number } from 'prop-types';
import { placementPropType, animatePropTypes, restrictHidePropTypes, animateDefaultProps, restrictDefaultProps } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import { a as isFunction } from '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import _Popover from './styled.js';
import 'focus-trap';
import { a as TrapFocus } from '../chunk-abb87050.js';

var PopoverPopover = function PopoverPopover(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible,
      trapFocus = _ref.trapFocus,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "isVisible", "trapFocus"]);

  return createElement(_Popover, _extends({
    visible: isVisible
  }, props), trapFocus ? createElement(TrapFocus, {
    isActive: isVisible
  }, function (_ref2) {
    var fallbackFocusRef = _ref2.fallbackFocusRef,
        initialFocusRef = _ref2.initialFocusRef;
    return createElement(Box, {
      elementRef: fallbackFocusRef
    }, isFunction(children) ? children({
      initialFocusRef: initialFocusRef
    }) : children);
  }) : isFunction(children) ? children({}) : children);
};

var popoverPopoverPropTypes = _objectSpread({
  children: oneOfType([node, func]).isRequired,
  className: string,
  isVisible: bool,
  flip: bool,
  gutter: oneOfType([number, string]),
  placement: placementPropType,
  shift: bool,
  trapFocus: bool
}, animatePropTypes, restrictHidePropTypes);

PopoverPopover.propTypes = popoverPopoverPropTypes;

var popoverPopoverDefaultProps = _objectSpread({
  className: undefined,
  flip: true,
  gutter: 12,
  isVisible: false,
  placement: 'bottom',
  shift: true,
  trapFocus: false
}, animateDefaultProps, restrictDefaultProps, {
  hideOnEsc: true,
  hideOnClickOutside: true
});

PopoverPopover.defaultProps = popoverPopoverDefaultProps;
var C = PopoverPopover;
export default C;
export { PopoverPopover, popoverPopoverDefaultProps, popoverPopoverPropTypes };